export default __webpack_public_path__ + "static/media/010-fire truck.78ed2584.svg";